"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = exports.getAnimation = exports.generateUniqueID = exports.getComponentThemeStyles = void 0;

var lodash_1 = require("lodash");

var animations = require("react-animations");

var styled_components_1 = require("styled-components");

exports.getComponentThemeStyles = function (theme, componentName, variant, size) {
  var defaultStyles = lodash_1.get(theme, "components." + componentName + ".variants.default", {});
  var variantStyles = lodash_1.get(theme, "components." + componentName + ".variants." + variant, {});

  var styles = __assign(__assign({}, defaultStyles), variantStyles);

  var defaultSizing = lodash_1.get(theme, "components." + componentName + ".sizes.default", {});
  var sizingStyles = lodash_1.get(theme, "components." + componentName + ".sizes." + size, {});

  var sizing = __assign(__assign({}, defaultSizing), sizingStyles);

  return __assign(__assign({}, styles), sizing);
};

exports.generateUniqueID = function () {
  return Math.random().toString(36);
};

exports.getAnimation = function (name) {
  return styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), animations[name]);
};

exports.getColor = function (theme, themeStyles, colorName, val) {
  if (themeStyles === void 0) {
    themeStyles = {};
  }

  return theme.colors[val] || themeStyles[colorName] || val;
};

var templateObject_1;